import * as React from 'react'
import { memo } from 'react'
const SvgLocationArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 11.552 12"
  >
    <path
      d="M7.855 12 6.007 6.483H0L11.552 0Z"
      data-name="Icon map-location-arrow"
    />
  </svg>
)
const Memo = memo(SvgLocationArrow)
export default Memo
